import backend from '@common/backend';

import { bookFromBe } from './books';

const BASE = '/students/programs';

export interface IGetStudentProgramsQuery {
	service_id: number;
	student_id: number;
	limit?: number;
}

export interface IGetStudentSimpleProgramsQuery {
	student_id?: number;
	service_id: number;
	page?: number;
	limit?: number;
}

interface IGetStudentProgramQuery {
	student_id: number;
	group_id: number;
}

export const studentProgramFromBE = (program: any) => ({
	// @TODO: Remove when BE will be fixed
	...program,
	books: program?.books?.length ? program.books.map(bookFromBe) : [],
});

export const getStudentPrograms = (query: IGetStudentProgramsQuery) =>
	backend
		.get(`${BASE}/list`, { params: query })
		.then((programs: any) => programs.map(studentProgramFromBE));

export const getStudentSimplePrograms = (query: IGetStudentSimpleProgramsQuery) =>
	backend.get(`${BASE}`, { params: query });

export const getStudentProgram = (programId: number, query: IGetStudentProgramQuery) =>
	backend.get(`${BASE}/${programId}`, { params: query }).then(studentProgramFromBE);

export const getStudentIndivPrograms = (query: IGetStudentSimpleProgramsQuery) =>
	backend.get(`${BASE}/indiv`, { params: query });

export const getStudentIndivProgram = (programId: number, query: IGetStudentProgramQuery) =>
	backend.get(`${BASE}/indiv/${programId}`, { params: query }).then(studentProgramFromBE);
